import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getReportData,
    GetEmployeeTypesData
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;

} async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function getReportData(data) {
    var model = {
        year: parseInt(moment(data.month).format('YYYY')),
        month: parseInt(moment(data.month).format('MM')),
        collectionPointID: parseInt(data.collectionPointID),
        jobTypeID: parseInt(data.jobTypeID)
    };
    const response = await CommonPost('/api/AttendanceReportPluckingAndSundry/GetAttendanceReportPluckingAndSundryDetails', null, model)
    return response.data;
}